import { useSelector } from 'react-redux';

function getBankAccount(state) {
	return state?.entities?.bank?.debit_accounts?.[0];
}

export function getBankAccountId(state) {
	return getBankAccount(state)?.id;
}

export function getDisabledFeatures(state) {
	return getBankAccount(state)?.disabledFeatures;
}

export function useBankAccount() {
	return useSelector((state) => state?.entities?.bank?.debit_accounts?.[0]);
}

export function useUUID() {
	return useSelector((state) => state?.entities?.api_key?.uuid);
}
